(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bam-welcome-popup"]) return;
  try {
    
(() => {
  if (customElements.get('bam-welcome-popup')) return;
  customElements.define('bam-welcome-popup', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.config = JSON.parse(this.querySelector('[data-bw-config]').textContent);
      this.dialog = this.querySelector('dialog');
      this.native = this.querySelector('[data-bw-native]');
      this.step = 'drop';
      this.timers = new Set();
      this.events = new AbortController();
      this.storageKey = 'bam.welcome.v1';
      this.photoMedia = matchMedia('(min-width: 901px)');
      this.querySelector('.bw-preview').hidden = !this.config.preview;
      this.listen(this.querySelector('[data-bw-drop]'), 'click', () => this.drop());
      this.querySelectorAll('[data-bw-close]').forEach(el => this.listen(el, 'click', () => this.close()));
      this.listen(this.dialog, 'cancel', e => { e.preventDefault(); this.close(); });
      this.listen(this.dialog, 'close', () => this.restoreScroll());
      this.listen(this.dialog, 'keydown', e => this.trapFocus(e));
      this.listen(document, 'bam:welcome:open', () => this.open(true));
      this.listen(this.photoMedia, 'change', () => this.loadPhoto());
      this.listen(window, 'klaviyoForms', e => this.onKlaviyo(e));
      this.listen(document, 'shopify:section:select', e => {
        if (this.config.preview && e.detail?.sectionId === this.config.sectionId) this.open(true);
      });
      if (this.config.preview) {
        const form = this.querySelector('.bw-preview-form');
        this.listen(form, 'submit', e => {
          e.preventDefault();
          if (!form.reportValidity()) return;
          this.querySelector('[data-bw-success-copy]').textContent = this.config.strings.demo_success;
          this.showStep('success');
        });
        this.later(() => this.open(true), 100);
      } else {
        this.nativeObserver = new MutationObserver(() => {
          if (this.triggerReason && !this.dialog.open) this.tryAutoOpen();
        });
        if (this.native) this.nativeObserver.observe(this.native, {childList:true, subtree:true});
        if (this.eligible()) this.armTriggers();
      }
    }
    listen(target, type, handler) {
      target?.addEventListener(type, handler, {signal:this.events.signal});
    }
    later(fn, delay) {
      const id = setTimeout(() => { this.timers.delete(id); fn(); }, delay);
      this.timers.add(id);
      return id;
    }
    cancelTimer(id) { clearTimeout(id); this.timers.delete(id); }
    readState() {
      try { return {...JSON.parse(localStorage.getItem(this.storageKey) || '{}'), ...this.memoryState}; }
      catch { return this.memoryState || {}; }
    }
    remember(state) {
      if (this.config.preview) return;
      this.memoryState = {...this.readState(), ...state};
      try { localStorage.setItem(this.storageKey, JSON.stringify(this.memoryState)); } catch {}
    }
    eligible() {
      if (!this.config.enabled || this.config.subscribedCustomer || !this.config.allowedPage || this.hasOpened) return false;
      const state = this.readState(), now = Date.now(), params = new URLSearchParams(location.search);
      if (state.submittedUntil > now || state.dismissedUntil > now) return false;
      if (params.has('_kx') || params.get('utm_medium')?.toLowerCase() === 'email') return false;
      try { if (sessionStorage.getItem(this.storageKey + '.seen')) return false; } catch {}
      return true;
    }
    armTriggers() {
      this.triggerEvents = new AbortController();
      const checkScroll = () => {
        const page = document.scrollingElement || document.documentElement;
        const distance = page.scrollHeight - window.innerHeight;
        if (distance > 0 && page.scrollTop / distance >= this.config.scrollPercent / 100) this.trigger('scroll');
      };
      window.addEventListener('scroll', checkScroll, {passive:true, signal:this.triggerEvents.signal});
      window.addEventListener('resize', checkScroll, {passive:true, signal:this.triggerEvents.signal});
      this.delayTimer = this.later(() => this.trigger('timer'), this.config.delay * 1000);
      checkScroll();
    }
    trigger(reason) {
      if (this.triggerReason || !this.eligible()) return;
      this.triggerReason = reason;
      this.stopTriggers();
      this.tryAutoOpen();
    }
    stopTriggers() {
      this.triggerEvents?.abort();
      this.cancelTimer(this.delayTimer);
    }
    nativeReady() {
      return this.config.preview || !!this.native?.querySelector('form input, form button, input[type="email"]');
    }
    blocked() {
      const overlays = document.querySelectorAll('dialog[open], [aria-modal="true"], .klaviyo-form [role="dialog"], #upcart-popup.upcart-open, .upcart-public-component-cart.is-open');
      const visible = Array.from(overlays).some(el => !this.contains(el) && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden' && el.getAttribute('aria-hidden') !== 'true');
      return visible || document.documentElement.classList.contains('upcart-open') || document.body.classList.contains('upcart-open') || !!document.activeElement?.closest('input,textarea,select');
    }
    tryAutoOpen() {
      if (!this.triggerReason || !this.eligible() || this.dialog.open) return;
      if (document.hidden || this.blocked() || !this.nativeReady()) {
        if (!this.retryTimer && (this.autoRetries || 0) < 30) {
          this.autoRetries = (this.autoRetries || 0) + 1;
          this.retryTimer = this.later(() => { this.retryTimer = null; this.tryAutoOpen(); }, 2000);
        }
        return;
      }
      this.open();
    }
    loadPhoto() {
      if (this.dialog.open && this.photoMedia.matches) {
        const image = this.querySelector('[data-bw-photo]');
        if (!image.hasAttribute('src')) image.src = this.config.image;
      }
    }
    open(manual = false) {
      if (this.dialog.open || !this.isConnected || (!this.config.preview && !this.config.enabled)) return;
      if (!manual && !this.config.preview && !this.eligible()) return;
      if (!this.nativeReady()) return;
      this.stopTriggers();
      this.cancelTimer(this.retryTimer);
      this.previousFocus = document.activeElement;
      this.previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      this.dialog.showModal();
      this.hasOpened = true;
      this.loadPhoto();
      this.querySelector('[data-bw-step="' + this.step + '"] h2').focus({preventScroll:true});
      if (!this.config.preview) {
        try { sessionStorage.setItem(this.storageKey + '.seen', '1'); } catch {}
      }
      this.emit('view', {step:this.step, trigger:manual ? 'manual' : this.triggerReason});
    }
    restoreScroll() {
      if (this.previousOverflow !== undefined) {
        document.documentElement.style.overflow = this.previousOverflow;
        this.previousOverflow = undefined;
      }
      if (this.previousFocus?.isConnected) this.previousFocus.focus({preventScroll:true});
      this.previousFocus = null;
    }
    close() {
      if (!this.dialog.open) return;
      this.remember({dismissedUntil:Date.now() + this.config.cooldownDays * 86400000});
      this.dialog.close();
      this.restoreScroll();
      this.emit('dismiss', {step:this.step});
    }
    trapFocus(e) {
      if (e.key !== 'Tab') return;
      const items = Array.from(this.dialog.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')).filter(el => el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
      const first = items[0], last = items[items.length - 1];
      if (e.shiftKey && (document.activeElement === first || !items.includes(document.activeElement))) { e.preventDefault(); last?.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first?.focus(); }
    }
    showStep(step) {
      this.step = step;
      this.querySelectorAll('[data-bw-step]').forEach(el => { el.hidden = el.dataset.bwStep !== step; });
      const title = this.querySelector('[data-bw-step="' + step + '"] h2');
      this.dialog.setAttribute('aria-labelledby', title.id);
      this.querySelector('.bw-panel').scrollTop = 0;
      const progress = this.querySelectorAll('.bw-progress i');
      progress[0].classList.toggle('is-active', step === 'drop');
      progress[1].classList.toggle('is-active', step !== 'drop');
      if (this.dialog.open) title.focus({preventScroll:true});
      if (step === 'email') this.emit('email_view');
    }
    drop() {
      const button = this.querySelector('[data-bw-drop]');
      if (button.disabled) return;
      button.disabled = true;
      button.querySelector('span').textContent = this.config.strings.dropping;
      this.querySelector('.bw-game').classList.add('is-dropping');
      this.emit('reveal');
      this.later(() => this.showStep('email'), matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 1500);
    }
    onKlaviyo(event) {
      if (this.config.preview || event.detail?.formId !== this.config.formId || event.detail?.type !== 'submit' || this.submitted) return;
      this.submitted = true;
      this.remember({submittedUntil:Date.now() + 365 * 86400000});
      this.stopTriggers();
      this.cancelTimer(this.retryTimer);
      this.emit('submitted');
    }
    emit(action, detail = {}) {
      this.dispatchEvent(new CustomEvent('bam:welcome', {bubbles:true, detail:{action, variant:'welcome_native_v2', formId:this.config.formId, preview:this.config.preview, ...detail}}));
    }
    disconnectedCallback() {
      this.events?.abort();
      this.triggerEvents?.abort();
      this.nativeObserver?.disconnect();
      this.timers?.forEach(clearTimeout);
      if (this.dialog?.open) this.dialog.close();
      this.restoreScroll();
      this.initialized = false;
      this.hasOpened = false;
      this.triggerReason = null;
      this.retryTimer = null;
      this.autoRetries = 0;
    }
  });
})();


  } catch(e) { console.error(e); }
})();
})();
